// extracted by mini-css-extract-plugin
export default {"signupForm":"TopbarContainer_signupForm__sHXp9"};